export class SuggestedCategory0 {
  constructor(
    public category0: string,
    public email: string,
    public description = '',
    public id = '',
    public uid = ''
  ) {}
}
